import styled from 'styled-components'

export const ModalHeader = styled.div`
  width: 100%;
  background-color: ${props => props.theme.h1};
  padding: 5px 0;
  position: relative;
`
